<template>
    
  <b-container>
    <b-row >
      <b-col class="pr-0">
          <b-row>
            <b-col>
              <b-form-group class="m-0" label="Equipment">
                {{ $t('equipment_type.' + equipmentConfig.name) }}
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <img :src="equipmentIcon(equipmentConfig.icon)" width="50"/>
            </b-col>
          </b-row>
      </b-col>
    </b-row>

    <br />

    <b-row>
        <b-col cols="12">
            You are about to update equipments in bulk

            <br />

            Selected roof section: <strong> {{ componentData.roofSection.label || 'No label'}} </strong>
            <br />

            Selected equipments: <strong> {{componentData.equipments.map(e => (e.label || 'No label') ).join(', ')}} </strong>
        </b-col>
    </b-row>
    <b-row >
      <b-col class="pa-3 pb-1 text-center divider-legend-column">
        
          <b-badge pill class="divider-legend"> 
            Properties
          </b-badge>
        
      </b-col>
    </b-row>
    <b-row>
      <b-col class="">
        <b-form-group label="Assign divalto code">
          <multiselect
            v-model="selectedDivaltoCodes"
            :options="divaltoCodes"
            :multiple="true"
            :searchable="true"
            @search-change="search"
            placeholder="Type to search"
            :custom-label="getResultValue"
            track-by="id">
          </multiselect>

<!--           <autocomplete :search="search"
              :get-result-value="getResultValue"
              @submit="onDivaltoCodeSubmit"
              :defaultValue="(section.divalto_code || {}).short_description"
              :key="'section-' + section.id"
              ></autocomplete> -->
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="" cols="2">
        <template v-for="field,index in equipmentConfig.fields_data" >
            <b-col :key="`f-0-${index}`">
                <equipment-sub-fields :fields="fields" :index="index" :field="field" />
            </b-col>
            <template v-for="subfield,index in subfields(field,index)" >
                <b-col :key="`f-1-${index}`">
                    <equipment-sub-fields :fields="fields" :index="index" :field="subfield" />
                </b-col>
                <template v-for="subfield,index in subfields(subfield,index)" >
                    <b-col :key="`f-2-${index}`">
                        <equipment-sub-fields :fields="fields" :index="index" :field="subfield" />
                    </b-col>
                </template>
            </template>
        </template>
    
    </b-row>

    <b-row>
      <b-col>
        <!-- <b-btn variant="outline-dark rounded-lg" @click="closeSidebar()">ANNULER</b-btn> -->
        <b-btn 
          class="ml-2 rounded-lg" 
          variant="primary"
          @click="submitHandler()">
          
          UPDATE
          <b-spinner v-if="loading" small label="Loading..."></b-spinner>
        </b-btn>
      </b-col>
    </b-row>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>

import {ProjectMixin} from '@/mixins';
import { mapGetters, mapState } from 'vuex'
import EquipmentSubFields from '../EquipmentSubFields.vue';
import Multiselect from 'vue-multiselect'

export default {
  name: "SectionInfoDrawer",
  mixins: [ProjectMixin],

  data(){
    return {
      loading: false,
      equipmentData: {},
      fields: {},
      draggable: false,
      prevSectionId: null,
      selectedDivaltoCodes: []
    }
  },
  props: {
        componentData: Object,
    },
  components:{
      EquipmentSubFields,
      Multiselect
  },

  mounted(){
  },

  computed: {
    ...mapState(['sections']),
    
    ...mapGetters({
      selectedShape: 'gmap/selectedShape',
      currentDrawingTool: 'sections/currentDrawingTool',
      currentEquipmentConfig: 'sections/currentEquipmentConfig',
      divaltoCodes: 'divaltoCodes/items',
      project: 'projects/item',
      copyData: 'sections/copyData',
      allShapes: 'gmap/allShapes',
    }),
    ...mapGetters({
        equipments: 'equipments/items',
    }),

    equipmentConfig(){
        return this.equipments.filter(ec => ec.id == this.componentData.equipmentConfig.id)[0]
    },
  },
  
  watch: {

  },
  
  methods: {
    search(input) {

      return new Promise((resolve) => {
        if (input.length < 2) {
          return resolve([])
        }

        this.$store.dispatch('divaltoCodes/all', { 
          config: { 
            params: { 
              filters: { 
                short_description_cont: input,
                element_code_cont: input,
                m: 'or'
              } 
            } 
          }   
        }).then((data) => {
            resolve(data.data)
          })
      })
    },

    equipmentIcon(icon){
      return require(`@/assets/equipment_icons/${icon}`);
    },

    async submitHandler(){
        
        const responses = await Promise.all(this.componentData.equipments.map( equipment => {
            let payload = {
                divalto_code_ids: (this.selectedDivaltoCodes || []).map(c => c.id),
                equipment_detail: {
                    equipment_config: this.equipmentConfig,
                    equipment_config_id: this.equipmentConfig.id,
                    data: this.fields,
                    id: (equipment.equipment_detail || {}).id
                }
            }
            
          return this.$store.dispatch('sections/bulkUpdate', {
            projectId: equipment.project_id,
            id: equipment.id,
            payload: {
              section: payload
            },
            config: {
              params: {
                include: ['equipment_detail', 'equipment_detail.equipment_config']
              }
            },
          }).then(resp => {
            console.log(resp.data.data)
            this.$store.dispatch("gmap/updateShapeFromDimension", {section: resp.data.data, data: {...this.fields, ...{useSectionFromShape: true}}})
          })
            
        })
      )
      this.$store.dispatch('ui/modal.close')
    },

    subfields(field, index){
      if(index in this.fields && 'options' in field && !Array.isArray(field.options)){
        return (field.options[this.fields[index]] || {}).fields || []
      }else{
        return [];
      }            
    },

    getResultValue(result){
      return (`(${result.element_code}) ` + result.short_description)
    },
  }
  
}
</script>
